import { render, staticRenderFns } from "./page-not-found.vue?vue&type=template&id=5639f4df&"
import script from "./page-not-found.vue?vue&type=script&lang=ts&"
export * from "./page-not-found.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports